import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Space } from 'antd';

const RunChecks = ({ checks }) => {
  if (!Array.isArray(checks) || checks.length === 0) return null;

  return (
    <Space direction="vertical" style={{ width: '100%', marginBottom: 16 }} size="small">
      {checks.map((check) => (
        <Alert
          key={check.id || check.message}
          type={check.level === 'fail' ? 'error' : 'warning'}
          showIcon
          message={check.message}
        />
      ))}
    </Space>
  );
};

RunChecks.propTypes = {
  checks: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    level: PropTypes.string,
    message: PropTypes.string,
  })),
};

RunChecks.defaultProps = {
  checks: null,
};

export default RunChecks;
